
  import { defineComponent } from 'vue';
  import { mapMutations } from 'vuex';

  import FileLocalMultiUploadRedesigned from '@/common/components/redesigned/fileUploads/FileLocalMultiUploadRedesigned.vue';
  import constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import { buildFormDataByObject } from '@/common/utils/file';

  import calculationApi from '../api/Calculation';
  import CalculationForm from '../components/common/CalculationForm.vue';
  import CalculationPageWrapper from '../components/common/CalculationPageWrapper.vue';
  import { CALCULATION_COMMON_GETTERS_NAME, CALCULATION_COMMON_MUTATIONS_NAME } from '../store/calculationCommon/name';
  import { TCalculationActiveInfo, UploadingDataStatusTypes } from '../types/calculation-common';
  import { TDBFFiles } from '../types/dbf-uploading';
  import { getFileFieldSubtitle } from '../utils/calculation';

  export default defineComponent({
    name: 'DBFUploading',
    components: {
      CalculationForm,
      FileLocalMultiUploadRedesigned,
      CalculationPageWrapper,
    },
    mixins: [security],
    data(): {
      files: TDBFFiles;
      isUploadingFile: boolean;
    } {
      return {
        files: {
          fts: [],
          trade: [],
        },
        isUploadingFile: false,
      };
    },
    mounted() {
      this.checkPermissionAndRedirect(constants.Permissions.ForeignTradeAnalyticsDbfLoaderUpload);
    },
    computed: {
      FILE_PATH() {
        return 'dbf';
      },
      getFileSubtitle(): string {
        return getFileFieldSubtitle(this.FILE_PATH);
      },
      getUploadingDataStatus(): TCalculationActiveInfo {
        return this.$store.getters[CALCULATION_COMMON_GETTERS_NAME.getUploadingDataStatus];
      },
      getType(): UploadingDataStatusTypes {
        return UploadingDataStatusTypes.DBF_UPLOADING;
      },
      getIsFormLoading(): boolean {
        return (
          (this.getUploadingDataStatus.type === this.getType && this.getUploadingDataStatus.isProgress) ||
          this.isUploadingFile
        );
      },
      getIsLoading(): boolean {
        return this.getIsFormLoading || !!this.getUploadingDataStatus.processingId;
      },
    },
    methods: {
      ...mapMutations({
        setUploadingDataStatus: CALCULATION_COMMON_MUTATIONS_NAME.setUploadingDataStatus,
      }),
      async handleSubmitForm() {
        try {
          this.isUploadingFile = true;
          const processingId = (await calculationApi.startDbfRecalculation(buildFormDataByObject(this.files))).data;

          const newUploadingDataStatus: TCalculationActiveInfo = {
            isProgress: true,
            type: this.getType,
            processingId,
          };

          this.setUploadingDataStatus(newUploadingDataStatus);
        } catch (error) {
          console.error(error);
        } finally {
          this.isUploadingFile = false;
        }
      },
    },
  });
